import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import '../../components/common/Table.css';
import TotalCount from '../../components/common/TotalCount/TotalCount';
import { baseurl } from '../../api';
import { useCheckboxClick } from '../../checkboxclick';
import SearchBox from '../../components/common/Search/SearchBox';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
const pageKey = "customers"


const Customers = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const [selectedItem, setSelectedItem] = useState(null); 
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [items, setItems] = useState([]);
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const searchCategories = ['Company'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];
  const navigate = useNavigate();
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  


  const fetchCustomers = async () => {
    try {
      const params = {
        search: searchParams.term,
        search_argument: searchParams.argument,
        filter: selectedFilterOption === "Default" ? undefined : selectedFilterOption.toLowerCase(),
        sort: mapSortOptionToQuery(selectedSortOption),
      };
      
      const response = await authenticatedAxios.get(`${baseurl}organization/`, { params });
  
      if (response.data.response_code === 1) {
        setItems(response.data.data);
      } else {
        console.error("Unexpected response code:", response.data.response_code);
      }
    } catch (error) {
      // Handle permission denied by redirecting to permission-denied page
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error("Error fetching customers:", error);
      }
    }
  };
  

  useEffect(() => {
    fetchCustomers();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedSortOption]);

  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case "A-Z":
        return "a_to_z";
      case "Z-A":
        return "z_to_a";
      case "Newest":
        return "newest";
      case "Oldest":
        return "oldest";
      default:
        return "newest";
    }
  };


  const handleArchiveSelectedItems = async (action) => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}organization/archive/`, {
        id_list: selectedItems,
      });

      if (response.status >= 200 && response.status < 300) {
        fetchCustomers();
        resetCheckboxState(); 
        closePopups();
      } 
    } catch (error) {
    }
  };

  const handleDelete = async () => {
    try {
      const response = await authenticatedAxios.delete(
        `${baseurl}organization/?id=${selectedItem.id}`
      );
  
      if (response.status >= 200 && response.status < 300) {
        setIsDeletePopupOpen(false); 
        fetchCustomers(); 
        return;
      }
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      // console.error('Error deleting plan:', error);
    }
  };

  const handleArchive = async () => {
    try {
        const response = await authenticatedAxios.get(`${baseurl}organization/archive/?id=${selectedItem.id}`);
        if (response.status >= 200 && response.status < 300) {
            await fetchCustomers();  
            closePopups();      
        } 
    } catch (error) {
    }
  };

  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };

  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
  };


  const handleSearchSelect = (searchCategory,searchTerm) => {
    setSearchParams({
      term: searchTerm,                   
      argument: searchCategory.toLowerCase(), 
    });
  };
  const handleUserDetailClick = (userId) => {
    navigate(`/customer-detail/${userId}`); 
  };

  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };

  const handleDeleteClick = async (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  const closePopups = () => {
    setIsArchivePopupOpen(false);
    setSelectedItem(null);
    setIsDeletePopupOpen(false)
    setSelectedItem([])
  };

  
  const handleExportComplete = () => {
    resetCheckboxState();
  };

  const deletePopupFields = [
    { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
  ];


  return (
    <div className='whole-container'>  
      <div className='top-heading'>
        <PageHeader pageName="Subscription /" nestedpageName="Customers"  linkTo="" /> 
        <div className='export-container'>

        <ArchiveSelectedItem
          selectedItems={selectedItems}
          items={items}
          onArchiveSelected={handleArchiveSelectedItems}
        />
        <ExportLabel
          exportUrl={`${baseurl}organization/export/`}
          selectedIds={selectedItems}
          onExportComplete={handleExportComplete}
        />
        </div>
      </div>     
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>Customers</h1>
        </div>
        <div className='pagename-right-container'>
          <TotalCount TotalName="Total Customers" TotalCount={items.length} />
          <SearchBox categories={searchCategories} onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term}/>
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption}/>
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption}/>
        </div>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
              <tr className='common-table-thead-tr'>
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />Company Name
              </th>
              <th>Phone Number</th>
              <th>Email</th>
              <th>Plan</th>
              <th>Active Users</th>
              <th>Currency</th>
              <th></th>
            </tr>
          </thead>
          <tbody className='common-table-tbody'>
          {items.length > 0 ? (
              items.map((customer) => (            
                <tr key={customer.id}className={customer.is_archived ? 'archived-item' : ''}>
                  <td className='d-flex ai-center'>
                    <input
                      className="table-selectbox table-child-selectbox"
                      type="checkbox"
                      checked={selectedItems.includes(customer.id)}
                      onChange={() => handleChildCheckboxChange(customer.id)}
                    />
                    <span onClick={() => handleUserDetailClick(customer.id)} className="blue company-name">{customer.name}</span>
                    
                  </td>
                  
                  <td>{customer.mobile_number}</td>
                  <td className='txt-lc'>{customer.email}</td>
                  <td>{customer.plan}</td>
                  <td><span className='green'>{customer.active_user_count}/</span>{customer.total_user_count}</td>
                  <td>
                    {customer.currency_symbol && customer.currency_name
                      ? `${customer.currency_symbol} ${customer.currency_name}`
                      : "Free plan"}
                  </td>
                  <td className="actions common-action">
                    <ArchiveIcon onClick={() => handleArchiveClick(customer)} isArchived={customer.is_archived} />     
                    <DeleteIcon onClick={() => handleDeleteClick(customer)} />
                                       
                  </td>             
                </tr>
             ))
             ) : (
               <tr>
                 <td colSpan="7">No customers found.</td>
               </tr>
             )}             
          </tbody>
        </table>
      </div>
      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived || false}
        archivename={selectedItem?.name || 'this user'}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />
      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived }
        archivename={selectedItem?.name}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />
      <DeletePopup
        isOpen={isDeletePopupOpen}
        title="Delete User"
        fields={deletePopupFields}
        onSave={handleDelete}
        onClose={closePopups}
      />
    </div>
  );
};

export default Customers;